import React from "react"
import { MultiSelect as PrimeMultiSelect } from "primereact/multiselect"
import ProgressSpinner from "./misc/ProgressSpinner.atom"
import { clsx } from "../../utils/strings.utils"

/**
 * @param {import("primereact/multiselect").MultiSelectProps} props
 */
const MultiSelect = (props) => {
  return (
    <PrimeMultiSelect
      {...props}
      panelClassName={clsx(props.panelClassName, props.loading && "is-loading")}
      className={clsx(props.className, props.loading && "is-loading")}
      optionLabel={props.loading ? "noop1" : props.optionLabel}
      optionValue={props.loading ? "noop2" : props.optionValue}
      onChange={props.loading ? () => {} : props.onChange}
      options={
        props.loading ?
          [
            {
              noop1: "",
              noop2: "",
            },
          ]
        : props.options
      }
      itemTemplate={
        props.loading ? () => <ProgressSpinner /> : props.itemTemplate
      }
    />
  )
}

export default MultiSelect
